import DeleteIcon from '@mui/icons-material/Delete';
import DOMPurify from 'dompurify';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { formatDateTime } from "../utils/utils";
import commonStyles from './Common.module.css';
import EntitiesDelete from './EntitiesDelete';
import styles from './Note.module.css';

function Note({ userName, text, createdAt, onDelete }: INoteProps) {
    const [isDeleteWindowOpen, setIsDeleteWindowOpen] = useState(false);

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                {formatDateTime(createdAt)} ({userName || "unknown user"})
                {onDelete && <DeleteIcon fontSize="small" className={commonStyles.clickableIcon} onClick={() => setIsDeleteWindowOpen(true)} />}
            </div>
            {!!text && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}></div>}
            {isDeleteWindowOpen && (
                <EntitiesDelete
                    entityName="Comment"
                    entityCount={1}
                    onCancel={() => setIsDeleteWindowOpen(false)}
                    onDelete={() => {
                        onDelete!();
                        setIsDeleteWindowOpen(false);
                    }}
                />
            )}
        </div>
    );
}

export default observer(Note);

interface INoteProps {
    userName?: string;
    text: string;
    createdAt: Date;
    onDelete?: () => void;
}
